<template>
	<div class="deposit-page">
		<section class="sec-10">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_deposit_page_v2.sec_10.title.one') }}
					<strong>
						{{ $t('new_ui.personal_deposit_page_v2.sec_10.title.two') }}
					</strong>
				</h2>
				<p>
					{{ $t('new_ui.personal_deposit_page_v2.sec_10.desc.one') }}
				</p>
				<div class="btn-box">
					<a href="/auth/login" class="btn-type-01">
						{{ $t('new_ui.personal_deposit_page_v2.sec_10.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.personal_deposit_page_v2.sec_10.btn.two') }}
					</a>
				</div>
				<div class="img-box">
					<img v-if="!isMobile" :src="img.imgDepositSec10" alt="" />
					<img v-if="isMobile" :src="img.imgDepositSec10M" alt="" />
				</div>
			</div>
		</section>
		<section class="sec-11">
			<div class="container-box">
				<div class="content-box">
					<h3>
						{{ $t('new_ui.personal_deposit_page_v2.sec_11.title.one') }}
					</h3>
					<p>{{ $t('new_ui.personal_deposit_page_v2.sec_11.desc.one') }}</p>
				</div>
			</div>
		</section>
		<section class="sec-04">
			<div class="container-box">
				<h3 class="title">
					{{ $t('new_ui.personal_deposit_page_v2.sec_04.title') }}
				</h3>
				<div class="card-box">
					<div class="card-content card-content-01">
						<div class="txt">
							<h5>
								{{
									$t(
										'new_ui.personal_deposit_page_v2.sec_04.cards.one.title.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_deposit_page_v2.sec_04.cards.one.title.two',
									)
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_deposit_page_v2.sec_04.cards.one.description.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_deposit_page_v2.sec_04.cards.one.description.two',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_deposit_page_v2.sec_04.cards.one.description.three',
									)
								}}
							</p>
						</div>
						<img :src="img.iconDeposit01" alt="" />
					</div>
					<div class="card-content card-content-02">
						<div class="txt">
							<h5>
								{{
									$t(
										'new_ui.personal_deposit_page_v2.sec_04.cards.two.title.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_deposit_page_v2.sec_04.cards.two.title.two',
									)
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_deposit_page_v2.sec_04.cards.two.description.one',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_deposit_page_v2.sec_04.cards.two.description.two',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_deposit_page_v2.sec_04.cards.two.description.three',
									)
								}}
							</p>
						</div>
						<img :src="img.iconDeposit02" alt="" />
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgDepositSec10 from '@/assets/images/v2/img-deposit-sec-10.png';
import imgDepositSec10M from '@/assets/images/v2/img-deposit-sec-10-m.png';
import iconDeposit01 from '@/assets/images/v2/icon/icon-deposit-01.svg';
import iconDeposit02 from '@/assets/images/v2/icon/icon-deposit-02.svg';

export default {
	data: () => {
		return {
			mobile: false,
			img: {
				imgDepositSec10,
				iconDeposit01,
				iconDeposit02,
				imgDepositSec10M,
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
